import axios from "axios";

export const state = {
    sellproductdetails: [],
};

export const getters = {
    sellproductdetails: state => state.sellproductdetails,
};

export const mutations = {
    setSellProductDetails(state, newValue) {
        state.sellproductdetails = newValue
    },
};

export const actions = {
    fetchSellProductDetails({ commit }) {
        axios.get('/orders').then(res => {
            commit('setSellProductDetails', res.data.orders)
        })
    },
};
